import React, { memo } from 'react';
import { BlockStyleControls, InlineStyleControls } from './StandardToolbarButtons';
import { CustomControls } from './CustomToolbarButtons';
import { Wrapper, Inner } from './Toolbar.Styles';
import { LinkControls } from './LinkToolbarButtons';
export var Toolbar = memo(function (_a) {
    var editorState = _a.editorState, onChange = _a.onChange, readOnly = _a.readOnly, color = _a.color, bg = _a.bg;
    if (readOnly)
        return null;
    return (React.createElement(Wrapper, { bg: bg },
        React.createElement(Inner, { bg: bg, color: color },
            React.createElement(BlockStyleControls, { editorState: editorState, onToggle: onChange, bg: bg }),
            React.createElement(InlineStyleControls, { editorState: editorState, onToggle: onChange, bg: bg }),
            React.createElement(CustomControls, { editorState: editorState, onToggle: onChange, bg: bg }),
            React.createElement(LinkControls, { editorState: editorState, onToggle: onChange, bg: bg }))));
});
